import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { FiMenu, FiX, FiArrowUpRight } from "react-icons/fi";
import "./header.css";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  // Prevent body scrolling when sidebar is open
  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "auto";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [menuOpen]);

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <>
      {/* Header */}
      <header className="premium-header">
        <div className="container-fluid header-container">
          {/* Logo */}
          <NavLink to="/" className="brand-logo " onClick={closeMenu}>
            <img src="/images/logo.png" alt="Logo" />
          </NavLink>

          {/* Desktop Navigation */}
          <nav className="desktop-nav">
            {/* <NavLink to="/" className="nav-item">
              Home
            </NavLink> */}

            <NavLink to="/features" className="nav-item">
              Features
            </NavLink>

            <NavLink to="/enterprice" className="nav-item">
              Enterprise
            </NavLink>

            <NavLink to="/about" className="nav-item">
              About Us
            </NavLink>

            <NavLink to="/contact" className="nav-item">
              Contact Us
            </NavLink>
          </nav>

          {/* Desktop CTA */}
          <div className="header-action">
            <NavLink to="/contact" className="header-cta">
              <span>Let's Talk</span>
              <FiArrowUpRight />
            </NavLink>
          </div>

          {/* Mobile Menu Button */}
          <button
            className={`mobile-menu-btn ${menuOpen ? "active" : ""}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Toggle menu"
          >
            {menuOpen ? <FiX /> : <FiMenu />}
          </button>
        </div>
      </header>

      {/* Mobile Overlay */}
      <div
        className={`mobile-overlay ${menuOpen ? "show" : ""}`}
        onClick={closeMenu}
      />

      {/* Mobile Half Sidebar */}
      <aside className={`mobile-sidebar ${menuOpen ? "open" : ""}`}>
        {/* Sidebar Header */}
        <div className="sidebar-header">
          <NavLink to="/" className="sidebar-logo" onClick={closeMenu}>
            <img src="/images/logo.png" alt="Logo" className="w-75" />
          </NavLink>

          <button className="sidebar-close" onClick={closeMenu}>
            <FiX />
          </button>
        </div>

        {/* Mobile Navigation */}
        <nav className="mobile-nav">
          <NavLink to="/" className="mobile-nav-link" onClick={closeMenu}>
            <span>01</span>
            <strong>Home</strong>
            <FiArrowUpRight />
          </NavLink>

          <NavLink
            to="/features"
            className="mobile-nav-link"
            onClick={closeMenu}
          >
            <span>02</span>
            <strong>Features</strong>
            <FiArrowUpRight />
          </NavLink>

          <NavLink to="/about" className="mobile-nav-link" onClick={closeMenu}>
            <span>03</span>
            <strong>About Us</strong>
            <FiArrowUpRight />
          </NavLink>

          <NavLink
            to="/enterprice"
            className="mobile-nav-link"
            onClick={closeMenu}
          >
            <span>04</span>
            <strong>Enterprise</strong>
            <FiArrowUpRight />
          </NavLink>

          <NavLink
            to="/contact"
            className="mobile-nav-link"
            onClick={closeMenu}
          >
            <span>05</span>
            <strong>Contact</strong>
            <FiArrowUpRight />
          </NavLink>
        </nav>

        {/* Sidebar Bottom */}
        <div className="sidebar-bottom">
          <p>Have a project in mind?</p>

          <NavLink
            to="/contact"
            className="sidebar-contact"
            onClick={closeMenu}
          >
            Start a Conversation
            <FiArrowUpRight />
          </NavLink>

          <div className="sidebar-line" />

          <small>© {new Date().getFullYear()} Your Company</small>
        </div>
      </aside>
    </>
  );
};

export default Header;
